export class UpdateGradeCalculation {
    static readonly type = '[GradingScheme] UpdateGradeCalculation';

    constructor(
        public payload: {
            moduleId: string;
            value: string;
        }
    ) {}
}
